var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filterWrapper rangeFilter",
      class: { activeRange: _vm.activeRange },
    },
    [
      _c(
        "div",
        [
          _c("h3", { staticClass: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.name) + " "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.draggValue) } }),
          ]),
          _c(
            "vue-slider",
            _vm._b(
              {
                ref: "slider",
                attrs: {
                  clickable: false,
                  height: 2,
                  dotSize: 10,
                  lazy: true,
                  tooltip: "always",
                  tooltipPlacement: "bottom",
                  tooltipFormatter: _vm.conf.formatter,
                  enableCross: true,
                },
                on: { "drag-end": _vm.setRequestValue, dragging: _vm.dragg },
                model: {
                  value: _vm.rangeValue,
                  callback: function ($$v) {
                    _vm.rangeValue = $$v
                  },
                  expression: "rangeValue",
                },
              },
              "vue-slider",
              _vm.conf,
              false
            )
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }